import { Phone } from "lucide-react";
import { PHONE, PHONE_TEL } from "../data";
import { Reveal } from "./Reveal";

export const CtaBand = () => (
  <section data-testid="full-cta-band" className="border-y border-gold/20 bg-navy-dark py-16 sm:py-20">
    <div className="section-wrap text-center">
      <Reveal>
        <h2 className="mx-auto max-w-3xl font-serif text-3xl font-bold tracking-tight text-cream sm:text-4xl lg:text-5xl">
          Planning a Celebration or Looking for a Comfortable Stay?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base text-cream/70">
          Get in touch with Kasdol Hotel and let us help you plan your visit.
        </p>

        <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row sm:flex-wrap">
          <a href="#marriage-enquiry" data-testid="cta-band-book-hall" className="btn-gold w-full sm:w-auto">
            Book Marriage Hall
          </a>
          <a href="#rooms-availability" data-testid="cta-band-book-room" className="btn-outline w-full sm:w-auto">
            Book a Room
          </a>
          <a href="#reserve-table" data-testid="cta-band-reserve-table" className="btn-outline w-full sm:w-auto">
            Reserve a Table
          </a>
        </div>

        <a
          href={PHONE_TEL}
          data-testid="cta-band-call-now"
          className="mt-9 inline-flex items-center gap-2.5 font-serif text-2xl font-semibold text-gold transition-colors hover:text-cream sm:text-3xl"
        >
          <Phone className="h-6 w-6" /> {PHONE}
        </a>
      </Reveal>
    </div>
  </section>
);
